import FormFields from "../../common/FormFields";
import useForm from "../../../hooks/common/useForm";
import useSet from "../../../hooks/common/useSet";
import { Alert, Button } from "antd";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API_LOGIN, API_OTP_VERIFICATION } from "../../../utils/apis";
import { useAuth } from "../../../context/AuthContext";
import { otpFields } from "../../../utils/otp_verification";
import AuthLayout from "./AuthLayout";

const OtpVerification = () => {
  const location = useLocation();
  //   const navigate = useNavigate();

  const { error, uploadData, success, submitting, data } = useSet();
  const {
    uploadData: resendAgain,
    success: resendSuccess,
    data: resendData,
  } = useSet();

  const { updateFormValue, form, onChange } = useForm();
  const { login } = useAuth();

  const userLoginData = location?.state;

  const onSubmit = (e: any) => {
    e.preventDefault();
    uploadData({
      api: API_OTP_VERIFICATION,
      params: {
        ...form,
        action: "verify_otp",
        email: userLoginData?.data?.email,
      },
    });
  };

  useEffect(() => {
    if (success) {
      const { tokens, user } = data?.data;
      const userAuth = {
        access: tokens?.access_token,
        tran: user.tran_acccess,
        user,
      };
      login(userAuth);
      //   }
    }
  }, [success]);

  const handleResend = () => {
    let email = userLoginData?.data?.email;
    let password = userLoginData?.data?.password;
    resendAgain({
      api: API_LOGIN,
      params: { email, password, action: "request_otp" },
    });
  };

  return (
    <form onSubmit={onSubmit}>
      <AuthLayout
        title="Verify your account"
        subtitle={
          <>
            We sent a verification code to {userLoginData?.data?.email} and otp
            is{" "}
            {resendSuccess ? resendData?.data?.otp : userLoginData?.data?.otp}
          </>
        }
      >
        {Object.keys(error).length > 0 ? (
          <Alert
            className="font12"
            showIcon
            type="error"
            message="OTP error!"
          />
        ) : null}

        {resendSuccess ? (
          <Alert
            className="font12"
            showIcon
            type="success"
            message="OTP resent!"
          />
        ) : null}

        <FormFields
          fields={otpFields}
          updateFormValue={updateFormValue}
          form={form}
          onChange={onChange}
          error={error}
        />

        <Button type="primary" htmlType="submit" loading={submitting}>
          Verify OTP
        </Button>

        <span className="textCenter font12">
          Didn&apos;t receive a code?{" "}
          <span className="pointer primaryColor" onClick={handleResend}>
            Resend again
          </span>
        </span>
      </AuthLayout>
    </form>
  );
};

export default OtpVerification;
